<template>
  <nav
    v-if="tags.length"
    :aria-label="t('product.eventTags')"
    class="event-tags text-xs overflow-x-auto"
  >
    <ol class="inline-flex items-center flex-nowrap md:flex-wrap">
      <li
        v-for="(tag, i) in tags"
        :key="tag.id ?? tag.slug"
        class="inline-flex items-center shrink-0"
      >
        <NuxtLink
          :to="getEventTagLink(tag)"
          :data-testid="tag.slug"
          class="no-underline inline-flex items-center text-xs font-normal text-gray-700 hover:underline whitespace-nowrap"
        >
          {{ tag.name }}
        </NuxtLink>
        <div
          v-if="i + 1 < tags.length"
          class="m-3 block w-1 h-1 shrink-0 rounded-full bg-gray-400"
          aria-hidden="true"
        />
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import type { EventDescription } from '~/composables/types/event'

const { event } = defineProps<{
  event: EventDescription
}>()

const { t } = useI18n()
const { getEventTagLink } = useEventTagLink()

const tags = computed(() => eventGetters.getTags(event))
</script>

<style scoped>
.event-tags {
  scrollbar-width: none;
  @apply md:mt-2 mb-1;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
